import { api } from '@marketplace-web/core-api/core-api-client-util'

import { DeleteFeedbackArgs } from '../types/feedback'

export const deleteFeedback = ({ feedbackId }: DeleteFeedbackArgs) =>
  api.delete(`/user_feedbacks/${feedbackId}`)
